import { canChangePlan } from './canChangePlan';
import * as subscriptionStatuses from './subscriptionStatuses';
import { getCreateDbBtnPermissions } from './getCreateDbPermissions';
import { isSubscriptionLegacyPlan } from './isSubscriptionLegacyPlan';
import getIsRcpSubscriptionCreationPending from './getIsRcpSubscriptionCreationPending';
import getIsAaRcpSubscriptionCreationPending from './getIsAaRcpSubscriptionCreationPending';
import getIsClientPublicAccessBlocked from './getIsClientPublicAccessBlocked';
import { getIsSubExternalAa } from './getIsSubExternalAa/getIsSubExternalAa';
import { getIsSubExternal } from './getIsSubExternal/getIsSubExternal';
import { getIsSubInternal } from './getIsSubInternal/getIsSubInternal';
import { getIsSubReserved } from './getIsSubReserved/getIsSubReserved';

const subscriptionUtils = {
  ...subscriptionStatuses,
  canChangePlan,
  getCreateDbBtnPermissions,
  isSubscriptionLegacyPlan,
  getIsRcpSubscriptionCreationPending,
  getIsAaRcpSubscriptionCreationPending,
  getIsClientPublicAccessBlocked,
  getIsSubReserved,
  getIsSubInternal,
  getIsSubExternal,
  getIsSubExternalAa
};

export default subscriptionUtils;
